module.exports = __webpack_public_path__ + "static/media/star_empty.8cf9df0f.svg";